import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const MobileBackButton = () => {
  const navigate = useNavigate();

  const handleBack = (e) => {
    e.preventDefault();
    
    // Prefer: window.history.state && window.history.state.idx > 0
    if (window.history.state && typeof window.history.state.idx === 'number' && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate('/');
      }
    }
  };

  return (
    <button
      className="mobile-back-btn"
      onClick={handleBack}
      aria-label="Go back"
      type="button"
    >
      <ArrowLeft size={24} />
    </button>
  );
};

export default MobileBackButton;
